<template>
  <DepartmentFactsContactsRow v-bind="normalized" />
</template>

<script>
import DepartmentFactsContactsRow from '@/components/Departments/DepartmentFactsContactsRow.vue';
import { normalizeDepartmentFactsContactsData } from '@/helpers/departmentFactsContacts';

export default {
  name: 'AppDepartmentFactsContactsBlock',
  components: { DepartmentFactsContactsRow },
  props: {
    data: { type: Object, default: () => ({}) },
  },
  computed: {
    normalized() {
      return normalizeDepartmentFactsContactsData(this.data);
    },
  },
};
</script>
